import plusIcon from "../assets/svg/plus-table.svg";
import {apiDeleteTransfers, apiGetTransfers, apiGetTransfersExcel} from "../api/transferApi";
import {apiGetProjects} from "../api/projectApi";
import {apiFinancialsList} from "../api/financialApi";
import {openTransferDrawer} from "../helpers/DrawerActions";
import {formatPrice} from "../helpers";
import {apiGetBranches} from "../api/branchApi";
import {searchType} from "./FactorForm";
import getCurrency from "helpers/currencyHelper";

const defaultTableColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
    },
    {
        name: "مبلغ",
        key: "amount",
        filterParams: {
            column: "amount",
            columnType: "number",
        },
        getValue: (item) => `${formatPrice(item?.amount || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
        searchType: "quantitative",
    },
    {
        name: "مبدا",
        key: "fromName",
        filterParams: {
            column: "fromId",
            columnType: "string",
            relationModelName: "Financial",
            relationColumn: "name",
        },
    },
    {
        name: "مقصد",
        key: "toName",
        filterParams: {
            column: "toId",
            columnType: "string",
            relationModelName: "Financial",
            relationColumn: "name",
        },
    },
    {
        name: "شرح",
        key: "description",
        filterParams: {
            column: "description",
            columnType: "string",
        },
    },
    {
        name: "تاریخ",
        key: "date",
        filterParams: {
            column: "date",
            columnType: "date",
        },
        searchType: "date",
    },
    {
        name: "پروژه",
        key: "Project",
        searchKey: "title",
        getValue: (item) => {
            return item.Project?.title ?? "-";
        },
        filterParams: {
            column: "ProjectId",
            columnType: "string",
            relationModelName: "Project",
            relationColumn: "title",
        },
        searchType: searchType.autocomplete,
        dataKey: {
            column: "projects",
            key: "title",
        },
    },
    {
        name: "شعبه",
        key: "Branch",
        searchKey: "title",
        getValue: (item) => {
            return item.Branch?.title ?? "-";
        },
        filterParams: {
            column: "BranchId",
            columnType: "string",
            relationModelName: "Branch",
            relationColumn: "title",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "branches",
            key: "title",
        },
    },
];

export const transferIndexData = [
    {
        title: "همه",
        description: "",
        key: "all",
        label: "انتقال",
        pluralLabel: "انتقال ها",
        pageTitle: "انتقال ها",
        pageDescription: "لیست انتقال های کسب و کار",
        tableColumns: defaultTableColumns,
        disableDateFilter: true,
        actions: {
            view: {
                label: "مشاهده انتقال",
                openDrawer: openTransferDrawer,
            },
            add: {
                title: "ثبت انتقال",
                icon: plusIcon,
                url: "/transfers/add",
            },
            edit: {},
            fetch: apiGetTransfers,
            delete: apiDeleteTransfers,
            copy: true,
            excel: {
                export: apiGetTransfersExcel,
            },
            sort: {
                model: "Transfer",
            },
            archive: {
                model: 'transfer'
            }
        },
    },
];

export const transferFormData = {
    transfer: {
        title: "انتقال",
        inputs: [
            {
                formType: "transfer",
                outerWrapperClass:
                    "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 px-1 style-padding-inputs",
                active: true,
                type: "accountingCode",
                name: "accountingCode",
                label: "کد حسابداری",
                primary: true,
                maxLength: 20,
                options: [
                    {
                        label: "اتوماتیک",
                        value: true,
                    },
                    {
                        label: "دستی",
                        value: false,
                    },
                ],
            },
            {
                formType: "transfer",
                outerWrapperClass:
                    "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                type: "datePickerInput",
                name: "date",
                label: "تاریخ",
                required: true,
            },
            {
                formType: "transfer",
                outerWrapperClass:
                    "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                type: "price",
                name: "amount",
                label: "مبلغ انتقال",
                maxLength: 16,
                showInput: true,
            },
            {
                formType: "transfer",
                outerWrapperClass:
                    "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                name: "description",
                label: "شرح",
                maxLength: 64,
                primary: true,
            },
            {
                formType: "transfer",
                outerWrapperClass:
                    "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                type: "selectBox",
                addModal: {
                    props: {
                        component: "project",
                        title: false,
                        closeButton: false,
                        onFinish: (token) => apiGetProjects(token),
                    },
                },
                name: "Project",
                label: "پروژه",
                showInput: true,
                options: "projects",
            },
            {
                formType: "transfer",
                outerWrapperClass:
                    "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                type: "selectBox",
                addModal: {
                    props: {
                        component: "branch",
                        title: false,
                        closeButton: false,
                        onFinish: (token) => apiGetBranches(token),
                    },
                },
                name: "Branch",
                label: "شعبه",
                showInput: true,
                options: "branches",
            },
        ],
    },
    transferOrigin: {
        title: "مبدا",
        tabs: [
            {
                name: "بانک",
                key: "bank",
                inputs: [
                    {
                        formType: "transfer",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "financial",
                                title: false,
                                closeButton: false,
                                onFinish: (token) => apiFinancialsList("bank", token),
                            },
                        },
                        name: "from",
                        label: "بانک",
                        showInput: true,
                        required: true,
                        options: "banks",
                    },
                    {
                        formType: "transfer",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        type: "price",
                        name: "from_wage",
                        label: "کارمزد خدمات بانکی",
                        maxLength: 16,
                        showInput: true,
                    },
                    {
                        formType: "transfer",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        name: "from_reference",
                        label: "ارجاع",
                        maxLength: 64,
                    },
                ],
            },
            {
                name: "تنخواه گردان",
                key: "fund",
                inputs: [
                    {
                        formType: "transfer",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "financial",
                                title: false,
                                closeButton: false,
                                onFinish: (token) => apiFinancialsList("fund", token),
                            },
                        },
                        name: "from",
                        label: "تنخواه گردان",
                        showInput: true,
                        required: true,
                        options: "funds",
                    },
                    {
                        formType: "transfer",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        name: "from_reference",
                        label: "ارجاع",
                        maxLength: 64,
                    },
                ],
            },
            {
                name: "صندوق",
                key: "cashier",
                inputs: [
                    {
                        formType: "transfer",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "financial",
                                title: false,
                                closeButton: false,
                                onFinish: (token) => apiFinancialsList("cashier", token),
                            },
                        },
                        name: "from",
                        label: "صندوق",
                        showInput: true,
                        required: true,
                        options: "cashiers",
                    },
                    {
                        formType: "transfer",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        name: "from_reference",
                        label: "ارجاع",
                        maxLength: 64,
                    },
                ],
            },
        ],
    },
    transferDestination: {
        title: "مقصد",
        tabs: [
            {
                name: "بانک",
                key: "bank",
                inputs: [
                    {
                        formType: "transfer",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "financial",
                                title: false,
                                closeButton: false,
                                onFinish: (token) => apiFinancialsList("bank", token),
                            },
                        },
                        name: "to",
                        label: "بانک",
                        showInput: true,
                        required: true,
                        options: "banks",
                    },
                    // {
                    //     formType: "transfer",
                    //     outerWrapperClass: 'col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top',
                    //     type: 'currency',
                    //     name: 'to_wage',
                    //     label: 'کارمزد خدمات بانکی',
                    //     maxLength: 16,
                    //     showInput: true,
                    // },
                    {
                        formType: "transfer",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        name: "to_reference",
                        label: "ارجاع",
                        maxLength: 64,
                    },
                ],
            },
            {
                name: "تنخواه گردان",
                key: "fund",
                inputs: [
                    {
                        formType: "transfer",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "financial",
                                title: false,
                                closeButton: false,
                                onFinish: (token) => apiFinancialsList("fund", token),
                            },
                        },
                        name: "to",
                        label: "تنخواه گردان",
                        showInput: true,
                        required: true,
                        options: "funds",
                    },
                    {
                        formType: "transfer",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        name: "to_reference",
                        label: "ارجاع",
                        maxLength: 64,
                    },
                ],
            },
            {
                name: "صندوق",
                key: "cashier",
                inputs: [
                    {
                        formType: "transfer",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "financial",
                                title: false,
                                closeButton: false,
                                onFinish: (token) => apiFinancialsList("cashier", token),
                            },
                        },
                        name: "to",
                        label: "صندوق",
                        showInput: true,
                        options: "cashiers",
                    },
                    {
                        formType: "transfer",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        name: "to_reference",
                        label: "ارجاع",
                        maxLength: 64,
                    },
                ],
            },
        ],
    },
};
